import { useState, useEffect } from 'react'
import { getBaseUrl, getCurrentLoginToken } from '../../callApi'
import { bustRequest } from '@signavio/kraken'
import { FileT } from '../../..'

export const useFetchFile = (fileId: Nullable<string>) => {
  const [file, setFile] = useState<Nullable<FileT>>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)

  const token = getCurrentLoginToken()

  useEffect(() => {
    if (!fileId) return

    const fetchFile = async () => {
      setLoading(true)
      setError(false)

      try {
        const response = await fetch(
          bustRequest(`${getBaseUrl()}/files/${fileId}`),
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        )
        if (!response.ok) {
          throw new Error('Failed to fetch file')
        }
        const data = await response.json()
        setFile(data)
      } catch (error) {
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    void fetchFile()
  }, [fileId, token])

  return { file, loading, error }
}
